module.exports = __webpack_public_path__ + "img/funeng.d99592a3.png";